import React, { Children } from 'react';
import { PolicyModal } from './PolicyModal';
type PrivacyPolicyModalProps = {
  onClose: () => void;
};
export const PrivacyPolicyModal = ({
  onClose
}: PrivacyPolicyModalProps) => {
  return <PolicyModal title="Privacy Policy" onClose={onClose} data-id="element-716">
      <div className="space-y-6 text-[#6B4B3E]" data-id="element-717">
        <p className="text-sm text-[#6B4B3E]/75" data-id="element-718">Last Updated: May 18, 2025</p>
        <p data-id="element-719">
          Welcome to Story Bunny AI (the "Website"), an AI-powered storytelling
          tool designed for children and their families, operated by Story Bunny
          AI LLC ("we," "us," or "our"). This Privacy Policy explains how we
          collect, use, and protect your information when you use our Website.
        </p>
        <p data-id="element-720">
          By using Story Bunny AI, you agree to the terms of this Privacy
          Policy.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-721">1. Information We Collect</h3>
        <p data-id="element-722">We collect the following types of information:</p>
        <div className="space-y-4 pl-6" data-id="element-723">
          <div data-id="element-724">
            <p className="font-medium" data-id="element-725">a. Account Information:</p>
            <p data-id="element-726">
              We collect personal information that you voluntarily provide when
              you create an account, such as your name and email address. When
              used by parents or guardians on behalf of their child, we may
              collect the parent's name and email address.
            </p>
          </div>
          <div data-id="element-727">
            <p className="font-medium" data-id="element-728">b. Story Data & Activity:</p>
            <p data-id="element-729">
              We collect anonymous usage data, including interactions with the
              Website, time spent, story selections, and input used to generate
              stories. This helps us improve user experience and performance.
            </p>
          </div>
          <div data-id="element-730">
            <p className="font-medium" data-id="element-731">c. Cookies & Device Data:</p>
            <p data-id="element-732">
              We use cookies and similar technologies to enhance your
              experience, track usage patterns, and analyze traffic. You can
              manage cookie preferences through your browser settings.
            </p>
          </div>
        </div>
        <h3 className="text-lg font-bold mt-8" data-id="element-733">
          2. How We Use Your Information
        </h3>
        <p data-id="element-734">We use the information we collect to:</p>
        <ul className="list-disc pl-6 space-y-2" data-id="element-735">
          <li data-id="element-736">Provide and personalize the Story Bunny AI experience</li>
          <li data-id="element-737">Improve our technology and user interface</li>
          <li data-id="element-738">
            Communicate with you about your stories or account (if applicable)
          </li>
          <li data-id="element-739">Maintain the safety and integrity of our platform</li>
        </ul>
        <h3 className="text-lg font-bold mt-8" data-id="element-740">3. Sharing Your Information</h3>
        <p data-id="element-741">
          We do not sell or rent your personal information. We may share limited
          data:
        </p>
        <ul className="list-disc pl-6 space-y-2" data-id="element-742">
          <li data-id="element-743">
            With service providers that support our operations (e.g., hosting or
            analytics)
          </li>
          <li data-id="element-744">
            If required by law or to protect the rights and safety of our users
          </li>
          <li data-id="element-745">
            With your consent, for example, if you choose to share a story
          </li>
        </ul>
        <h3 className="text-lg font-bold mt-8" data-id="element-746">4. Data Retention & Deletion</h3>
        <p data-id="element-747">
          You may request that we delete your account and associated personal
          information at any time by contacting support@storybunny.ai. We will
          process such requests within 30 days. Usage data that is anonymized
          may be retained for internal analysis.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-748">5. Children's Privacy</h3>
        <p data-id="element-749">
          Story Bunny AI is designed for use by children with the involvement of
          a parent or guardian. We do not knowingly collect personal information
          from children under 13 without verifiable parental consent. If you
          believe we have collected such information in error, please contact us
          immediately and we will take appropriate steps to remove it.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-750">
          6. Changes to This Privacy Policy
        </h3>
        <p data-id="element-751">
          We may update this policy to reflect changes in our practices or legal
          requirements. When we do, we'll revise the "Last Updated" date above.
          Continued use of the Website after changes are made indicates your
          acceptance of the updated policy.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-752">7. Contact Us</h3>
        <p data-id="element-753">
          If you have any questions about this Privacy Policy or our data
          practices, please contact us at:
        </p>
        <p className="mt-4" data-id="element-754">
          Story Bunny AI LLC
          <br data-id="element-755" />
          📧 support@storybunny.ai
          <br data-id="element-756" />
          🌐 www.storybunny.ai
        </p>
      </div>
    </PolicyModal>;
};